export default __webpack_public_path__ + "adfee6dcc91eddba569cbc7891745a7b.md";